import styled from 'styled-components/macro';
import Autocomplete from '@mui/material/Autocomplete';

const StyleAutoComplete = styled(Autocomplete)``;

export {StyleAutoComplete};
